import { createSelector } from "@reduxjs/toolkit";
//#region src/redux/i18n/selectors.ts
var pickI18nState = () => (store) => store.i18n;
var selectLocale = () => createSelector([pickI18nState()], (buildState) => buildState?.locale);
var selectCountry = () => createSelector([pickI18nState()], (buildState) => buildState?.country);
//#endregion
export { pickI18nState, selectCountry, selectLocale };

//# sourceMappingURL=selectors.js.map